import { mapState, mapActions } from 'vuex'

export const fileManagerMethods = mapActions('fileManager', [
    'fetchList',
    'deletFile',
    'nextPage',
    'deleteFile',
    'deleteFolder',
    'getUserIp',
    'createItem',
    'putFile',
    'registerDownload',
])

export const fileManagerComputed = {
    ...mapState('fileManager', ['fileList', 'userIp']),
}